import {ColumnsOf83Criteria, ColumnsOf83CriteriaModal} from "./ColumnsOf83Criteria";
import {LIST_CRITERIA} from "../constants/commons";
import {QualityIndicatorColumns, QualityIndicatorModalColumns} from "./QualityIndicatorColumns";
import {QualityStandardColumns, QualityStandardModalColumns} from "./QualityStandardColumns";
import {SurgicalSafetyQualityColumns, SurgicalSafetyQualityModalColumns} from "./SurgicalSafetyQualityColumns";
import {TechnicalLevelColumns, TechnicalLevelModalColumns} from "./TechnicalLevelColumns";

const CriteriaColumns = (type?: number | null, props?: any) => {
  const {_83_TIEU_CHI, _CHI_SO_CHAT_LUONG, _TIEU_CHUAN_CHAT_LUONG, _XEP_CAP_CHUYEN_MON_KT, _MUC_DO_ATPT} = LIST_CRITERIA;

  switch (type) {
    case _CHI_SO_CHAT_LUONG.value:
      return QualityIndicatorColumns;
    case _TIEU_CHUAN_CHAT_LUONG.value:
      return QualityStandardColumns;
    case _XEP_CAP_CHUYEN_MON_KT.value:
      return TechnicalLevelColumns;
    case _MUC_DO_ATPT.value:
      return SurgicalSafetyQualityColumns;
    case _83_TIEU_CHI.value:
    default:
      return ColumnsOf83Criteria;
  }
};

const CriteriaModalColumns = (type?: number | null, props?: any) => {
  const {_83_TIEU_CHI, _CHI_SO_CHAT_LUONG, _TIEU_CHUAN_CHAT_LUONG, _XEP_CAP_CHUYEN_MON_KT, _MUC_DO_ATPT} = LIST_CRITERIA;

  switch (type) {
    case _CHI_SO_CHAT_LUONG.value:
      return QualityIndicatorModalColumns;
    case _TIEU_CHUAN_CHAT_LUONG.value:
      return QualityStandardModalColumns;
    case _XEP_CAP_CHUYEN_MON_KT.value:
      return TechnicalLevelModalColumns;
    case _MUC_DO_ATPT.value:
      return SurgicalSafetyQualityModalColumns;
    case _83_TIEU_CHI.value:
    default:
      return ColumnsOf83CriteriaModal;
  }
};

export {CriteriaColumns, CriteriaModalColumns}
